import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        role:'',
        header:''
    },
    mutations:{
        setHeader(state,header){
            state.header = header;
        },
        setRole(state,role){
            state.role = role;
        }
    },
    plugins: [persistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js